"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureExpProject = void 0;
const createApi_1 = require("../../../helpers/createApi");
const schemas_1 = require("./schemas");
const list = (caller) => async ({ accountId, _max_per_page, _page, search }) => {
    return caller(`/accounts/${accountId}/projects`)
        .get({ _page, _max_per_page, search })
        .then(schemas_1.FeatureExpProjectsWithPaginationSchema.parse);
};
const get = (caller) => async ({ accountId, projectId }) => {
    const url = `/accounts/${accountId}/projects/${projectId}`;
    return caller(url).get().then(schemas_1.FeatureExpOneProjectSchema.parse);
};
const post = (caller) => async ({ accountId, payload }) => caller(`/accounts/${accountId}/projects`).post(payload);
const patch = (caller) => async ({ accountId, id, payload }) => {
    return caller(`/accounts/${accountId}/projects/${id}`).patch(payload);
};
const remove = (caller) => async ({ accountId, id }) => caller(`/accounts/${accountId}/projects/${id}`).delete();
exports.featureExpProject = (0, createApi_1.createAPIFactory)({
    get,
    list,
    post,
    patch,
    delete: remove,
});
//# sourceMappingURL=api.js.map